<div class="c-switch" [class.c-switch--error]="showErrors && hasError('required')">
	<div class="c-switch__yes" [class.c-switch--active]="isValue(true)" (click)="setValue(true)">{{ YES }}</div>
	<div class="c-switch__no" [class.c-switch--active]="isValue(false)" (click)="setValue(false)">{{ NO }}</div>
</div>

<ng-container *ngIf="showErrors">
	<ng-content></ng-content>
</ng-container>
